import CartaId from '../../entities/CartaId';
import { RequestAWSAccountVPCModel } from './RequestAWSAccountVPCModel';

export class RequestAWSAccountModel {
	appName: string;

	accountName: string;

	environment: number;

	ownerUserId: string;

	custodianUserId: string;

	organizationId: string;

	cartaIds: CartaId[];

	accountUsedFor: string;

	accountGroups: Record<string, string[]>;

	internalOrder?: string;

	isManaged: boolean;

	isRetainedApp: boolean;

	requiresEc2Instances?: boolean;

	requiresPublicIpAddresses?: boolean;

	requiresNativeContainerServices?: boolean;

	requiresIsolation?: boolean;

	requiresDMZ: boolean;

	numOfDmzPublicIpAddresses?: string;

	vpcSizeId?: string;

	regionNames?: [];

	pocDurationDays?: string;

	networkConfig: RequestAWSAccountVPCModel[];

	isTier0: boolean;

	isCyberCritical: boolean;

	isECN: boolean;

	constructor(obj: any) {
		Object.assign(this, obj);
		if (!this.accountGroups) {
            this.accountGroups = {};
        }
	}
}
